import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import LineIcon from '../components/LineIcon';
import { useGarage } from './GarageContext';
import RecordSheet from './RecordSheet';
import Plate from './Plate';
import { formatDayMonthYear, formatMoney, plural, recordTitle } from './format';

// A API nao entrega nota fiscal nem PDF: os "documentos" sao as ordens de servico de cada
// atendimento (itens, valores e fotos), as mesmas do historico, organizadas como arquivo.
export default function DocumentsPage() {
  const { loading, vehicles, error, reload } = useGarage();
  const [selected, setSelected] = useState(null);

  const records = useMemo(() => {
    const unique = new Map();
    vehicles.forEach((v) => v.records.forEach((r) => { if (!unique.has(r.key)) unique.set(r.key, r); }));
    return [...unique.values()].sort((a, b) => (b.date ? b.date.getTime() : 0) - (a.date ? a.date.getTime() : 0));
  }, [vehicles]);

  return (
    <div className='gs-stack'>
      <header className='gs-greeting'>
        <span>Documentos</span>
        <h1>Documentos organizados</h1>
        <p className='gs-muted'>Ordens de serviço dos seus atendimentos, enviadas pelas empresas, junto do histórico.</p>
      </header>

      {loading && (
        <div className='gs-stack' aria-busy='true'>
          <div className='gs-skeleton gs-skeleton-row' />
          <div className='gs-skeleton gs-skeleton-row' />
        </div>
      )}

      {!loading && error && (
        <section className='gs-empty' role='alert'>
          <h2>Não foi possível carregar seus documentos</h2>
          <p>Tente novamente em alguns instantes.</p>
          <button type='button' className='gs-btn gs-btn-primary' onClick={reload}>Tentar novamente</button>
        </section>
      )}

      {!loading && !error && records.length === 0 && (
        <section className='gs-empty'>
          <span className='gs-empty-icon'><LineIcon name='file' size={28} /></span>
          <h2>Nenhum documento ainda</h2>
          <p>Quando uma empresa parceira registrar um atendimento, a ordem de serviço aparecerá aqui.</p>
          {vehicles.length === 0 && <Link className='gs-btn gs-btn-primary' to='/client/newvehicle'>Adicionar meu primeiro veículo</Link>}
        </section>
      )}

      {!loading && records.length > 0 && (
        <>
          <p className='gs-count'>{records.length} {plural(records.length, 'documento', 'documentos')}</p>
          <ul className='gs-doc-list'>
            {records.map((record) => (
              <li key={record.key}>
                <button type='button' className='gs-doc' onClick={() => setSelected(record)}>
                  <span className='gs-docs-icon'><LineIcon name='file' size={20} /></span>
                  <span className='gs-doc-text'>
                    <strong>{recordTitle(record)}</strong>
                    <span>{record.company.name}</span>
                    <span className='gs-doc-meta'>
                      {formatDayMonthYear(record.date)}
                      <Plate value={record.plate} size='xs' />
                      {record.photos.length > 0 && <span>{record.photos.length} {plural(record.photos.length, 'foto', 'fotos')}</span>}
                    </span>
                  </span>
                  {record.total !== null && <span className='gs-doc-value'>{formatMoney(record.total)}</span>}
                </button>
              </li>
            ))}
          </ul>
        </>
      )}

      {selected && <RecordSheet record={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
